import { useGetWithRefetch } from '../../../hooks/useFetchEndPoint';
import { DemoAnswer, DemoInfo } from './api/types';

export const useGetDemoInfo = (demoCode?: string) => {
  return useGetWithRefetch<DemoInfo>(`/api/v1/records/demo/?code=${demoCode}`, {
    running: !!demoCode,
  });
};

export const useGetDemoAnswers = () => {
  return useGetWithRefetch<DemoAnswer>('/api/v1/records/demo/answer/');
};
